import React from 'react';
import {
  color,
  viChevronLeft,
  VibeIcon,
} from 'vibeguide';

function CustomLeftArrow({
  onClick, ...rest
}) {
  const {
    carouselState: { currentSlide },
  } = rest;
  return (
    <div className={currentSlide === 0 ? 'loop-left-button disable' : 'loop-left-button'} onClick={() => onClick()}>
      <VibeIcon
        icon={viChevronLeft}
        color={color.white}
        size={34}
      />
    </div>
  );
}

export default CustomLeftArrow;
